var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18254_243564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.167 4H13.833C13.3469 4 12.8806 4.19312 12.5369 4.53687C12.1931 4.88063 12 5.34686 12 5.833V14L29 19L45 14V5.833C45 5.34686 44.8069 4.88063 44.4631 4.53687C44.1194 4.19312 43.6531 4 43.167 4Z",
    fill: "#41A5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 14H12V24L29 27L45 24V14Z",
    fill: "#2B7CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24V34L28 36L45 34V24H12Z",
    fill: "#185ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.833 44H43.167C43.6531 44 44.1194 43.8069 44.4631 43.4631C44.8069 43.1194 45 42.6531 45 42.167V34H12V42.167C12 42.6531 12.1931 43.1194 12.5369 43.4631C12.8806 43.8069 13.3469 44 13.833 44Z",
    fill: "#103F91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.167 12H12V37H24.167C24.6527 36.9984 25.118 36.8048 25.4614 36.4614C25.8048 36.118 25.9984 35.6527 26 35.167V13.833C25.9984 13.3473 25.8048 12.882 25.4614 12.5386C25.118 12.1952 24.6527 12.0016 24.167 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.167 13H12V38H23.167C23.6527 37.9984 24.118 37.8048 24.4614 37.4614C24.8048 37.118 24.9984 36.6527 25 36.167V14.833C24.9984 14.3473 24.8048 13.882 24.4614 13.5386C24.118 13.1952 23.6527 13.0016 23.167 13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.167 13H12V36H23.167C23.6527 35.9984 24.118 35.8048 24.4614 35.4614C24.8048 35.118 24.9984 34.6527 25 34.167V14.833C24.9984 14.3473 24.8048 13.882 24.4614 13.5386C24.118 13.1952 23.6527 13.0016 23.167 13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.167 13H12V36H22.167C22.6527 35.9984 23.118 35.8048 23.4614 35.4614C23.8048 35.118 23.9984 34.6527 24 34.167V14.833C23.9984 14.3473 23.8048 13.882 23.4614 13.5386C23.118 13.1952 22.6527 13.0016 22.167 13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.167 13H3.833C2.82066 13 2 13.8207 2 14.833V33.167C2 34.1793 2.82066 35 3.833 35H22.167C23.1793 35 24 34.1793 24 33.167V14.833C24 13.8207 23.1793 13 22.167 13Z",
    fill: "url(#paint0_linear_18254_243564)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52179 27.058C9.55779 27.341 9.58179 27.587 9.59279 27.798H9.63479C9.65079 27.598 9.68413 27.357 9.73479 27.075C9.78546 26.793 9.83113 26.5547 9.87179 26.36L11.7998 18.042H14.2928L16.2928 26.235C16.409 26.7445 16.4922 27.2609 16.5418 27.781H16.5748C16.6121 27.2771 16.6816 26.7761 16.7828 26.281L18.3778 18.038H20.6468L17.8448 29.958H15.1938L13.2938 22.064C13.2388 21.837 13.1758 21.54 13.1068 21.175C13.0378 20.81 12.9948 20.543 12.9778 20.375H12.9448C12.9228 20.569 12.8798 20.857 12.8158 21.239C12.7518 21.621 12.7005 21.9037 12.6618 22.087L10.8758 29.956H8.17979L5.36279 18.042H7.67279L9.40979 26.377C9.44879 26.548 9.48579 26.776 9.52179 27.058Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18254_243564",
    x1: 5.822,
    y1: 11.568,
    x2: 20.178,
    y2: 36.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146AC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18254_243564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordLogo);
export default __webpack_public_path__ + "static/media/word-logo.2b6589be894c8bad94e9d845ff6e615b.svg";
export { ForwardRef as ReactComponent };